import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
  margin: 10px;

  .bars-container {
    width: 1em;
    height: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: black;
    overflow: hidden;
    font-size: 64px;
    color: #4a9789;

    .bar {
      position: absolute;
      width: 0.16667em;
      height: 0.5em;
      background-color: currentColor;
      animation: growNshrink 1.5s infinite ease-in-out;
      top: 25%;
      @for $i from 1 through 5 {
        &:nth-child(#{$i}) {
          left: calc((#{$i} - 1) * 0.20833em);
          animation-delay: calc((5 - #{$i}) * -0.075s);
          background-color: lighten(#4a9789, $i * 5%);
        }
      }
  }

  @keyframes growNshrink {
    15% { transform: scaleY(2); }
    30% { transform: scaleY(1); }
  }
`;
